import { AutomationTypes } from '@pages-clean/central-monitoring/dataset-hub/interfaces/hub-dataset.interface';
import { components } from 'types/rest-schema';
// eslint-disable-next-line max-len
import { datasetDataViewConfigurations_OpraQueries_dataViewConfigurations_DataViewConfiguration as DataViewConfiguration } from '@queries/generated/central-monitoring.generated';

export type CreateObservationModel = components['schemas']['CreateObservationModel'];
export type UpdateObservationModel = components['schemas']['UpdateObservationModel'];
export type DeleteObservationModel = components['schemas']['DeleteObservationModel'];
export type GridType = components['schemas']['GridType'];
export type ObservationDto = components['schemas']['ObservationsDto'];
export type ObservationDetailsDto = components['schemas']['ObservationDetailsDto'];
export type DatasetResponseDto = components['schemas']['DatasetResponseDTO'];
export type ObservationBulkUpdateDto = components['schemas']['ObservationBulkUpdateDto'];

export interface ObservationsSiteDto extends ObservationDto {
    type: string;
    review_log_created_for_latest_dataset: string;
    has_integrated_actions: string;
}

export interface Site {
    id: number;
    name: string;
}
export interface Panel {
    name: string;
    reference: string;
    plotTitle: string;
}
export interface Owner {
    fullName: string;
    ref: string | null;
    groupedBy: string;
}

export interface ObservationProps {
    orgKey: string;
    studyRef: string;
    studyNumber: string;
    canEdit: boolean;
    isHalfScreen: boolean;
}

export interface AutomationStatusSetupProps {
    orgKey: string;
    studyRef: string;
    automationType: AutomationTypes;
}

// Keep in sync with BE ObservationType enum
export enum AssociationType {
    SiteHub = 0,
    StudyHub = 1,
    DataView = 2,
    ControlsHub = 3,
}

// Keep in sync with BE ObservationType enum
export enum ObservationType {
    Site = 0,
    Study = 1,
    Controls,
}

export const associationTypes: DataViewConfiguration[] = [
    {
        name: 'Site Hub',
        id: '1',
        __typename: 'DataViewConfiguration',
        inUse: true,
        isActive: true,
        panelIds: [],
        displayIndex: null,
        mainPanelId: null,
    },
    {
        name: 'Study Hub',
        id: '2',
        __typename: 'DataViewConfiguration',
        inUse: true,
        isActive: true,
        panelIds: [],
        displayIndex: null,
        mainPanelId: null,
    },
];

export function EnumConverter(associationType: DataViewConfiguration | null) {
    switch (associationType?.name) {
        case 'Site Hub':
            return AssociationType.SiteHub;
        case 'Study Hub':
            return AssociationType.StudyHub;
        case 'Controls Hub':
            return AssociationType.ControlsHub;
        default:
            return AssociationType.DataView;
    }
}

export enum FilterContext {
    AddObservation = 'AddObservation',
    AddAction = 'AddAction',
    AddReviewLog = 'AddReviewLog',
    ParentBulkUpdate = 'ParentBulkUpdate',
    ChildBulkUpdate = 'ChildBulkUpdate',
    DeleteSubjectObservation = 'DeleteSubjectObservation',
}

export enum ChipHeaders {
    ObservationsView = 1,
    ReviewLogView = 2,
    ActionView = 3,
    ReviewLogHistory = 4,
}

export const MonitoringToolKitTables = {
    Observations: 'grid_observations',
    Actions: 'grid_actions',
    SiteReviewLogs: 'site_grid_review_log',
    StudyReviewLogs: 'study_grid_review_log',
    ControlsReviewLogs: 'control_grid_review_log',
    SubjectObservations: 'subject_observations',
    SubjectReviewLogs: 'subject_review_logs',
    SubjectActions: 'subject_actions',
    SubjectReviewActivityLog: 'subject_review_activity_log',
};

export type Observation = {
    id: string;
    dataset_opened_on: string | null;
    type: string | null;
    association: string;
    association_active: string;
    panel: string | null;
    panel_active: string | null;
    site_id: string | null;
    observation_date: string | null;
    owner_name: string | null;
    owner_name_active: string | null;
    observation: string;
    root_cause: string | null;
    comments: string | null;
    closed_date: string | null;
    is_scatter_plot: string;
    created_by: string;
    created_date: string;
    updated_by: string;
    updated_date: string;
    decision: string;
    decision_active: string;
    reviews: string;
    open_actions: string;
    recent_action: string;
    status: string;
    record_id: string;
    site_name: string | null;
    review_log_created_for_latest_dataset: string;
    time_period: string | null;
    total_actions: string;
};

export interface BasicDropDownOption {
    id: number | null;
    fullName: string;
    groupedBy?: string;
    disabled?: boolean;
}

export const placeholder: BasicDropDownOption = {
    groupedBy: '',
    id: null,
    fullName: 'Select a value...',
    disabled: false,
};

export interface SelectedRowsProps {
    id: number;
    hasOpenActions: boolean;
}
